<script>
  import cursoServico from '../servico';
  import pagamentoServico from '../../pagamento/servico';
  
  export default {
    props: {
      dados: {
        type: Object,
        required: true, 
      },
      open: {
        type: Boolean,
        required: true,
      }
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
      }
    },
    beforeDestroy() {
      this.$events.off('recarregarCursos');
    },
    methods: {
      imprimir(idLancamento) {
        cursoServico
          .boleto(idLancamento)
          .then(boleto => {
            let pagina = window.open('about:blank');

            pagina.document.write(`${boleto.replace('Boleto.Net', 'Boleto')}`);
            pagina.document.getElementsByClassName('w150 cn8 Al Ab')[0].remove();
            pagina.stop();
          });
      },
      visualizaBoleto() {
        return !(
          this.dados.boletoMensalidade ||
          this.dados.pagSeguroMensalidade ||
          this.dados.getNetBoletoMensalidade ||
          this.dados.getNetCreditoMensalidade ||
          this.dados.getNetDebitoMensalidade
        );
      },
      pagarPagSeguroCheckout(lancamento) {
        $('#pagSeguroMensalidade').button('loading');
        $('#ModalPlataformasPgto').modal('show');

        pagamentoServico
          .pagarCheckout(lancamento)
          .then(retorno => {
            $('#pagSeguroMensalidade').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            var url = retorno.bodyText;
            window.open(url);
          })
          .catch(error => {
            $('#pagSeguroMensalidade').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            this.$swal(
              'Problema no processamento do pagamento pelo PagSeguro',
              error.bodyText,
              'error'
            );
          });
      },
      pagarBoletoGetNet(lancamento) {
        $('#getNetBoletoMensalidade').button('loading');

        $('#ModalPlataformasPgto').modal('show');

        pagamentoServico
          .pagarBoletoGetNet(lancamento)
          .then(retorno => {
            $('#getNetBoletoMensalidade').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            var url = retorno.bodyText;
            window.open(url);

            this.$events.emit('recarregarCursos');
          })
          .catch(error => {
            $('#getNetBoletoMensalidade').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            this.$swal(
              'Problema no processamento do pagamento pelo boleto GetNet',
              error.bodyText,
              'error'
            );
          });
      },
      pagarCreditoGetNet(lancamento) {
        $('#getNetCreditoMensalidade').button('loading');

        $('#ModalPlataformasPgto').modal('show');

        pagamentoServico
          .pagarCreditoGetNet(lancamento)
          .then(retorno => {
            $('#getNetCreditoMensalidade').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            var url = retorno.bodyText;
            window.open(url);
          })
          .catch(error => {
            $('#getNetCreditoMensalidade').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            this.$swal(
              'Problema no processamento do pagamento pelo crédito GetNet',
              error.bodyText,
              'error'
            );
          });
      },
      pagarDebitoGetNet(lancamento) {
        $('#getNetDebitoMensalidade').button('loading');

        $('#ModalPlataformasPgto').modal('show');

        pagamentoServico
          .pagarDebitoGetNet(lancamento)
          .then(retorno => {
            $('#getNetDebitoMensalidade').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            var url = retorno.bodyText;
            window.open(url);
          })
          .catch(error => {
            $('#getNetDebitoMensalidade').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            this.$swal(
              'Problema no processamento do pagamento pelo débito GetNet',
              error.bodyText,
              'error'
            );
          });
      },
      pagarCreditoIntGetNet(lancamento) {
        $('#getNetCreditoEstrangeiroMensalidade').button('loading');

        $('#ModalPlataformasPgto').modal('show');

        pagamentoServico
          .pagarCreditoGetNet(lancamento)
          .then(retorno => {
            $('#getNetCreditoEstrangeiroMensalidade').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            var url = retorno.bodyText;
            window.open(url);
          })
          .catch(error => {
            $('#getNetCreditoEstrangeiroMensalidade').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            this.$swal(
              'Problema no processamento do pagamento pelo crédito internacional GetNet',
              error.bodyText,
              'error'
            );
          });
      },
    }
  }
</script>

<template>
    <tbody class="no-borders">
      <tr class="pointer" @click="$emit('click')" :class="{'active': open}">
        <td><i :class="['fa', open ? 'fa-angle-down' : 'fa-angle-right']"></i> {{ dados.descricaoCurso }}</td>
        <td>{{ dados.nomeTurma }}</td>
      </tr>
      <tr class="active animated fadeIn" v-show="open">
        <td colspan="2">

          <table class="table table-striped table-hover no-margins">
            <thead>
              <tr>
                <th class="text-center">Situa&ccedil;&atilde;o</th>
                <th>Vencimento</th>
                <th>Baixa</th>
                <th>Nosso número</th>
                <th>Doc.</th>
                <th class="text-center">Valor</th>
                <th class="text-center">Juros</th>
                <th class="text-center">Multa</th>
                <th class="text-center">Desconto</th>
                <th class="text-center">Valor pago</th>
                <th class="text-center">Meio de pagamento</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="lancamento in dados.lancamentos" :class="{'success': lancamento.data}">
                <td class="text-center">
                  <i class="fa fa-check-circle pago" v-if="!!lancamento.data" v-tooltip="'Pago'"></i>
                  <i class="fa fa-exclamation-triangle pendente" v-if="!lancamento.data" v-tooltip="'Pendente'"></i>
                </td>
                <td>
                  {{ lancamento.dataVencimento | formatarNumeroEmData }}</td>
                <td>{{ lancamento.data | formatarNumeroEmData('---')
                  }}
                </td>
                <td>{{ lancamento.nossoNumero }}</td>
                <td>{{ lancamento.documento }}</td>
                <td class="text-center">{{ lancamento.valorReceberPagar | formatarNumero }}</td>
                <td class="text-center">{{ lancamento.juros | formatarNumero }}</td>
                <td class="text-center">{{ lancamento.multa | formatarNumero }}</td>
                <td class="text-center">{{ lancamento.desconto | formatarNumero }}</td>
                <td class="text-center">
                  {{ lancamento.valor | formatarNumero }}</td>
                <td class="text-center">
                  <button id="boletoMensalidade"
                          :disabled="(!!lancamento.data)"
                          v-if="(dados.estrangeiro == 0) && (dados.boletoMensalidade || visualizaBoleto())"
                          type="button"
                          class="btn btn-primary meioPagamentoCurso"
                          @click="imprimir(lancamento.idLancamento)"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Pagando...">
                    <i class="fa fa-print"></i>
                    Boleto
                  </button>
                  <button id="pagSeguroMensalidade"
                          :disabled="!!lancamento.data"
                          v-if="(dados.estrangeiro == 0) && dados.pagSeguroMensalidade"
                          type="button"
                          class="btn btn-white meioPagamentoCurso"
                          @click="pagarPagSeguroCheckout(lancamento)"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Pagando...">
                    <i class="fa fa-money"></i>
                    PagSeguro
                  </button>
                  <button id="getNetBoletoMensalidade"
                          :disabled="!!lancamento.data"
                          v-if="(dados.estrangeiro == 0) && dados.getNetBoletoMensalidade"
                          type="button"
                          class="btn btn-success meioPagamentoCurso"
                          @click="pagarBoletoGetNet(lancamento)"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Pagando...">
                    <i class="fa fa-barcode"></i>
                    Boleto GetNet
                  </button>
                  <button id="getNetCreditoMensalidade"
                          :disabled="!!lancamento.data"
                          v-if="(dados.estrangeiro == 0) && dados.getNetCreditoMensalidade"
                          type="button"
                          class="btn btn-warning meioPagamentoCurso"
                          @click="pagarCreditoGetNet(lancamento)"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Pagando...">
                    <i class="fa fa-credit-card"></i>
                    Crédito GetNet
                  </button>
                  <button id="getNetDebitoMensalidade"
                          :disabled="!!lancamento.data"
                          v-if="(dados.estrangeiro == 0) && dados.getNetDebitoMensalidade"
                          type="button"
                          class="btn btn-info meioPagamentoCurso"
                          @click="pagarDebitoGetNet(lancamento)"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Pagando...">
                    <i class="fa fa-credit-card-alt"></i>
                    Débito GetNet
                  </button>
                  <button id="getNetCreditoEstrangeiroMensalidade"
                          :disabled="!!lancamento.data"
                          v-if="(dados.estrangeiro == 1) && dados.getNetCreditoEstrangeiroMensalidade"
                          type="button"
                          class="btn btn-warning meioPagamentoCurso"
                          @click="pagarCreditoIntGetNet(lancamento)"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Pagando...">
                    <i class="fa fa-credit-card-alt"></i>
                    Crédito GetNet
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
</template>
<style>
  .meioPagamentoCurso {
    height: 35px;
    width: 140px;
    margin-right: 10px;
  }
  .pago {
    font-size: 1.40em;
    color: #1d9d2d;
    margin-left: 5px;
  }
  .pendente {
    font-size: 1.40em;
    color: #a6a915;
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/curso/componentes/TabelaDetalheLinha.vue